var React = require('react');

function PoundSign (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M8 236v40a12 12 0 0 0 12 12h28v-64H20a12 12 0 0 0-12 12zm204-12h-84v64h84a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M48 416V158c0-73.26 58-126 139.93-126 48.65 0 85.19 22.56 101.58 34.93a12 12 0 0 1 2.31 16.81 2.56 2.56 0 0 1-.2.26l-28.49 35.51a12 12 0 0 1-15.69 2.69c-11.77-7.35-34-18.85-57.65-18.85-37.23 0-61.79 24.82-61.79 57.08v254.42h122.51V364a12 12 0 0 1 12-12H308a12 12 0 0 1 12 12v104a12 12 0 0 1-12 12H12a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12z","className":"fa-primary","key":2})]);
}

PoundSign.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = PoundSign;

PoundSign.default = PoundSign;
